module.exports = __webpack_public_path__ + "static/img/ping_chen.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wmm/ping_chen.jpg
// module id = Y0gb
// module chunks = 0